// Minimal crypto surface for light pages: only sha256 + randomBytes (PKCE).
// Replaces crypto-browserify (~0.5 MB) which ships full RSA/DH/ECDH.
const createHash = require('sha.js');
const randomBytes = require('randombytes');

module.exports = {
    createHash,
    randomBytes,
};
